angular.module('rjmNg.filters').filter 'userpushToUploadedFile', ->
  # Prettify userpush.userpush to Uploaded File
  return (database) ->
    if database.connection.name is database.database.name and database.connection.name is 'userpush'
      return "Uploaded File"
    return "#{database.connection.name}.#{database.database.name}"
